import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

const CONFIG = {
  1: { medal: '🥇', label: 'אלוף/ה', height: 'h-28 sm:h-32', ring: 'ring-amber-400', bg: 'from-amber-400 to-yellow-500', size: 'w-20 h-20 sm:w-24 sm:h-24', order: 'order-2' },
  2: { medal: '🥈', label: 'מקום שני', height: 'h-20 sm:h-24', ring: 'ring-slate-300', bg: 'from-slate-300 to-slate-400', size: 'w-16 h-16 sm:w-20 sm:h-20', order: 'order-1' },
  3: { medal: '🥉', label: 'מקום שלישי', height: 'h-16 sm:h-20', ring: 'ring-orange-300', bg: 'from-orange-300 to-amber-600', size: 'w-16 h-16 sm:w-20 sm:h-20', order: 'order-3' },
};

export const WinnersPodium = ({ tournament }) => {
  if (tournament?.status !== 'completed' || !tournament.podium?.length) return null;
  const byPos = Object.fromEntries(tournament.podium.map((p) => [p.position, p]));

  const Column = ({ pos }) => {
    const p = byPos[pos];
    const c = CONFIG[pos];
    if (!p) return <div className={`flex-1 ${c.order}`}></div>;
    const inner = (
      <div className={`flex flex-col items-center gap-2 flex-1 ${c.order}`} data-testid={`winners-podium-pos-${pos}`}>
        <div className="relative">
          {pos === 1 && <span className="absolute -top-7 left-1/2 -translate-x-1/2 text-3xl animate-bounce">👑</span>}
          <Avatar className={`${c.size} ring-4 ${c.ring} shadow-xl border-2 border-white`}>
            {p.avatar && <AvatarImage src={p.avatar} alt={p.name} className="object-cover" />}
            <AvatarFallback className="bg-white text-slate-700 font-black text-2xl">{(p.name || '?').charAt(0)}</AvatarFallback>
          </Avatar>
          <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 text-2xl drop-shadow">{c.medal}</span>
        </div>
        <div className="text-center mt-2">
          <div className={`font-black text-white leading-tight ${pos === 1 ? 'text-lg sm:text-xl' : 'text-sm sm:text-base'}`}>{p.name}</div>
          <div className="text-white/80 text-[11px] font-bold">{c.label}</div>
        </div>
        <div className={`w-full max-w-[110px] ${c.height} rounded-t-2xl bg-gradient-to-b ${c.bg} shadow-inner flex items-start justify-center pt-2`}>
          <span className="text-white font-black text-2xl drop-shadow">{pos}</span>
        </div>
      </div>
    );
    return p.user_id ? <Link to={`/profile/${p.user_id}`} className={`flex-1 ${c.order}`}>{inner}</Link> : inner;
  };

  return (
    <div className="relative overflow-hidden rounded-3xl shadow-2xl mb-8" data-testid="winners-podium">
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-900 via-blue-900 to-emerald-900"></div>
      <div className="absolute -top-24 -right-24 w-72 h-72 bg-amber-400/20 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-24 -left-24 w-72 h-72 bg-emerald-400/20 rounded-full blur-3xl"></div>

      <div className="relative z-10 pt-8 px-4 sm:px-8">
        <div className="text-center mb-6">
          <div className="text-3xl mb-1">🎉🏆🎉</div>
          <h2 className="text-2xl sm:text-3xl font-black text-white">הזוכים בתחרות</h2>
          <p className="text-white/70 text-sm font-semibold">כל הכבוד לעולים על הפודיום!</p>
        </div>
        <div className="flex items-end justify-center gap-2 sm:gap-6 max-w-lg mx-auto">
          <Column pos={2} />
          <Column pos={1} />
          <Column pos={3} />
        </div>
      </div>
    </div>
  );
};
